angular.module('bmsApp.employee').controller('EmployeeImportCtrl', [
	'$state',
	'$scope',
	'$timeout',
	'$log',
	'notify',
	'FileSvc',
	'EmployeeSvc', function (
		$state,
		$scope,
		$timeout,
		$log,
		notify,
		FileSvc,
		EmployeeSvc) {

		$scope.employees = {
			csv: null,
		};

		$scope.enableSubmit = false;
		$scope.processing = false;

		$scope.dropzone = {
			config: {
				url: '/api/file/upload',
				parallelUploads: 3,
				maxFileSize: 30,
				addRemoveLinks: true,
				acceptedFiles: '.csv',
				eventHandlers: {
					success: function (file, response) {
						$scope.employees.csv = response.filepath;
						file.serverFilepath = response.filepath;
						$timeout(function () {
							$scope.$apply();
						}, 0);
					},
					drop: function (event) {
						$timeout(function () {
							$scope.$apply(function () {
								$scope.enableSubmit = false;
							});
						}, 0);
					},
					queuecomplete: function () {
						$scope.enableSubmit = this.files.length ? true : false;
						$timeout(function () {
							$scope.$apply(function () {
							});
						}, 0);
					},
					addedfile: function () {
						// Remove old csv if new one dragged in
						if (this.files[1] != null) {
							this.removeFile(this.files[0]);
						}
					},
					removedfile: function (file) {
						var self = this;
						FileSvc.delete(file.serverFilepath)
							.then(function (response) {
								$scope.enableSubmit = self.files.length ? true : false;
							}, function (error) {
							});
					}
				}
			}
		};

		$scope.submit = function () {
			if (angular.isString($scope.employees.csv) === false) {
				$scope.errors = [
					'You must upload a CSV'
				];
				return;
			}

			$timeout(function () {
				$scope.$apply(function () {
					$scope.errors = false;
				});
			}, 0);
			$scope.processing = true;
			EmployeeSvc.import($scope.employees)
				.then(function (response) {
					$scope.processing = false;
					notify({
						message: 'Employees imported successfully'
					});
					$state.go('main.employee.index');
				}, function (errors) {
					$scope.errors = errors;
					$scope.processing = false;
				});
		};

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit();
			},
			errorPlacement: function (error) {
				error.appendTo('#employee-import-errors');
			},
			errorContainer: '#employee-import-errors'
		};


	}]);
